import get from 'lodash/get'
import * as Sentry from '@sentry/browser'
import {
  CREATE_HOME_REQUEST,
  CREATE_HOME_SUCCESS,
  CREATE_HOME_FAILURE,
  FETCH_HOME_REQUEST,
  CREATE_HOME_FETCH_COMPILED_FAILURE,
  FETCH_HOME_SUCCESS
} from './actionTypes'
import { getHomeDetail as requestGetHomeDetail } from 'src/api/node/requests'
import { createHome as createHomeRequest } from 'src/api/mikasa/requests'
import { fetchClientHomes } from 'src/actions/client'
import {
  selectClientId,
  selectClientLegacyId
} from 'src/store/selectors/client'
import poll from 'src/actions/poll'
import TimeoutError from 'src/actions/TimeoutError'
import { redirect } from 'src/helpers/browser'
import { PATH_HELPERS } from 'src/constants/navigation'

export const createHomeFailure = error => ({
  type: CREATE_HOME_FAILURE,
  error: get(error, 'response.data.errors', get(error, 'message'))
})

export const createHome = home => async (dispatch, getState) => {
  dispatch({
    type: CREATE_HOME_REQUEST
  })

  const state = getState()
  const clientId = selectClientId(state)
  try {
    const response = await createHomeRequest({
      ...home,
      clientId
    })

    dispatch({
      type: CREATE_HOME_SUCCESS,
      data: response.data
    })

    const homeId = response.data.data.legacyRef
    dispatch(fetchCompiledHome(homeId))

    const legacyClientId = selectClientLegacyId(state)
    dispatch(fetchClientHomes(legacyClientId))
  } catch (error) {
    dispatch(createHomeFailure(error))

    Sentry.captureException(error)
  }
}

export const fetchCompiledHome = homeId => async (dispatch, getState) => {
  dispatch({
    type: FETCH_HOME_REQUEST,
    id: homeId
  })

  try {
    const response = await poll(
      () => requestGetHomeDetail(homeId),
      response => get(response, 'data.processed')
    )

    dispatch({
      type: FETCH_HOME_SUCCESS,
      data: response.data,
      loading: true
    })
    redirect(PATH_HELPERS.home.buildPath(selectClientId(getState()), homeId))
  } catch (error) {
    dispatch({
      type: CREATE_HOME_FETCH_COMPILED_FAILURE,
      error: error.message,
      timeout: error instanceof TimeoutError
    })

    Sentry.captureException(error, {
      extra: {
        homeId
      }
    })
  }
}
